import { render } from "preact"
import { Explore } from "./Explore"
import { Home } from "./Home"
import { Quiz } from "./Quiz"
import { quizState } from "./quizState"
import { Results } from "./Results"
import { Verify } from "./Verify"

export function rerender() {
  const homeMount = document.getElementById("home")
  if (homeMount) render(<Home />, homeMount)

  const quizMount = document.getElementById("quiz")
  if (quizMount) {
    quizMount.classList.toggle("active", quizState.screen === "quiz")
    render(quizState.screen === "quiz" ? <Quiz /> : null, quizMount)
  }

  const resultsMount = document.getElementById("results")
  if (resultsMount) {
    resultsMount.classList.toggle("active", quizState.screen === "results")
    render(quizState.screen === "results" ? <Results /> : null, resultsMount)
  }

  const verifyMount = document.getElementById("verify")
  if (verifyMount) render(<Verify />, verifyMount)

  const exploreMount = document.getElementById("explore")
  if (exploreMount) render(<Explore />, exploreMount)
}
